import { get } from 'lodash-es';
// eslint-disable-next-line
import NewRelicBrowser from 'new-relic-browser';
import { User } from 'reducer/auth';

type NewRelic = typeof NewRelicBrowser;
type InitLogger = NewRelic | null;

let logger: InitLogger = null;

/**
 * Type guard to check NewRelic has been initialised and present.
 *
 * @param loggerVar - logger var above
 * @returns
 */
function initLogger(loggerVar: InitLogger): loggerVar is NewRelic {
  if (loggerVar) {
    return true;
  }
  if (window.newrelic) {
    logger = window.newrelic;
    return true;
  }
  return false;
}

/**
 * Set  the user id and email in New Relic
 *
 * @param user The redux stored user object
 */
export const setUser = (user: User) => {
  if (gtag) {
    gtag('set', { user_id: get(user, 'id', null) });
    gtag('set', 'user_properties', {
      account_id: get(user, 'accountId', null),
    });
  }

  if (initLogger(logger)) {
    logger.setCustomAttribute('user.id', get(user, 'id', ''));
    logger.setCustomAttribute('user.email', get(user, 'email', ''));
    logger.setCustomAttribute(
      'user.username',
      `${get(user, 'firstName', '')} ${get(user, 'lastName', '')}`,
    );
  }
};

/**
 * Unset the current user for new relic. E.g. for logout etc.
 */
export const clearUser = () => {
  if (window.gtag) {
    window.gtag('set', { user_id: null });
  }
  if (initLogger(logger)) {
    logger.setCustomAttribute('user.id', '');
    logger.setCustomAttribute('user.email', '');
    logger.setCustomAttribute('user.username', ``);
  }
};

/**
 * Log an error to NewRelic.
 *
 * @param err - if you have an error object use this.
 * @param attr - obj with key values you want logged against the error.
 * @param msg - if you don't have an error object, use this and one will be
 *  created for you and sent to NewRelic.
 */
export const logError = (
  // eslint-disable-next-line
  err: Error | null = null,
  attr?: { [key: string]: string | number },
  msg?: string,
) => {
  if (initLogger(logger)) {
    if (err) {
      logger.noticeError(err, attr);
      return;
    }
    const newErr = new Error(msg);
    logger.noticeError(newErr, attr);
  }
};

export const logSignup = (method: 'email' | 'microsoft') => {
  if (window.fbq) {
    window.fbq('track', 'CompleteRegistration', {
      status: true,
      content: method,
    });
  }

  if (window.lintrk) {
    window.lintrk('track', { conversion_id: 7869004 });
  }

  if (window.gtag) {
    window.gtag('event', 'sign_up', {
      method: 'microsoft',
      category: 'signup',
    });
  }

  if (window.rdt) {
    window.rdt('track', 'SignUp');
  }
};
